import { APP_ROUTES } from 'constants/routes';

import { DEFAULT_SEO_IMAGE, getOpenGraphUrl, getPageSeoBreadcrumbs } from './SeoHelpers';

import type {
  IProductDetails, PageSeoProps, TFunction
} from 'types';

export function getProductPageSeoProps(t: TFunction, product?: IProductDetails): PageSeoProps {
  if (!product) return { seoProps: undefined, breadcrumbs: undefined };

  const {
    metaTitle, metaDescription, name, images
  } = product || {};

  const image = images?.[0]?.thumbnail?.default;

  return {
    seoProps: {
      title: metaTitle || name,
      description: metaDescription,
      openGraph: {
        description: metaDescription,
        images: image ? [{ url: image }] : DEFAULT_SEO_IMAGE,
        url: getOpenGraphUrl()
      },
      noindex: false
    },
    breadcrumbs: getProductPageBreadcrumbs(t, product)
  };
}

function getProductPageBreadcrumbs(t: TFunction, product: IProductDetails) {
  if (!product) return [];
  const { breadcrumbs } = product;
  return getPageSeoBreadcrumbs(t, breadcrumbs, { base: APP_ROUTES.PRODUCTS, includesLast: true });
}
